var exports = {
  "Dk": "x43aef4ae--3878a5--carousel",
  "hP": "x43aef4ae--3878a5--slides",
  "gw": "x43aef4ae--3878a5--progress-bar",
  "Rx": "x43aef4ae--3878a5--progress-bar__wrapper",
};

module.exports = exports;
